export default "__VITE_PUBLIC_ASSET__875728f7__"